<lib-sticky-modal [height]="'55rem'">
  <lib-sticky-header [stickyCollectionKey]="'add-edit-locations'" [stickyZ]="10" [stickyOrder]="0">
    <div class="modal-header no-bottom-border" fxLayout="row" fxLayoutAlign="space-between center">
      <div class="modal-title" ngbAutofocus>Edit Required Locations</div>
      <div
        class="text-link"
        [class.disabled]="!(viewModel.nSelectedLocationIds$ | async)"
        appThrottleClick
        (throttleClick)="viewModel.connectToSelectedRequiredLocationIds([])">
        Clear
      </div>
    </div>
  </lib-sticky-header>
  <lib-sticky-body>
    <div
      #contentContainer
      class="template-add-or-edit-required-locations-container"
      libStickyAutoPosition
      [stickyCollectionKey]="'add-edit-locations'"
      [stickyZ]="10"
      [stickyOrder]="1">
      <div class="desc-and-search" fxLayout="column" [style.gap.rem]="1">
        <div class="modal-description">
          <p>
            Select which locations the templated menu should be <span class="required-text">required</span> at. The
            templated menu will automatically be created for all selected locations and cannot be deleted from those
            locations.
          </p>
          For locations that are not required, the user can add and remove the template at their location.
        </div>
        <hr class="no-margin" />
        <app-search-with-look-ahead
          [placeHolder]="'Search for a location'"
          [lookAheadItems]="viewModel.allLocations$ | async"
          [searchTheseProperties]="['name', 'address', 'city', 'state', 'country']"
          [disablePopper]="true"
          [nLookAheadItems]="10000"
          [outputAllItemsWhenSearchIsEmpty]="true"
          (searchText)="viewModel.connectToSearchString($event)"
          (lookAheadHits)="viewModel.connectToSearchedLocations($event)">
        </app-search-with-look-ahead>
        <ng-container [ngSwitch]="(viewModel.searchedLocations$ | async)?.length > 0">
          <div *ngSwitchCase="true" class="select-all-locations-container">
            <div fxLayout="row" fxLayoutAlign="start center">
              <app-group-selection
                #groupSelectionComponent
                [selection]="viewModel.locationsVisibleOnScreen$ | async"
                [selectedIds]="viewModel.selectedRequiredLocationIdsAsStringList$ | async"
                (bulkAdd)="viewModel.addLocationIds($event)"
                (bulkRemove)="viewModel.removeLocationIds($event)">
              </app-group-selection>
              <div class="n-selected">
                <span *ngIf="viewModel.nSelectedLocationIds$ | async as nSelected" class="checked-count">
                  ({{ nSelected }})
                </span>
              </div>
            </div>
            <div class="select-all-locations-text">Select All Locations Below</div>
          </div>
          <div *ngSwitchCase="false" class="empty-search-state">No locations found.</div>
        </ng-container>
      </div>
    </div>
    <div class="template-add-or-edit-required-locations-container">
      <app-template-location-selection-group
        *ngFor="
          let grouping of viewModel.searchedLocationsGroupedByProvince$ | async | keyvalue: incompleteLocationsLast;
          trackBy: viewModel.trackByProvince
        "
        [province]="grouping?.key"
        [locations]="grouping?.value"
        [updatedRequiredLocationIds]="viewModel.selectedRequiredLocationIds$ | async"
        [selectedIds]="viewModel.selectedRequiredLocationIdsAsStringList$ | async"
        (addLocationIds)="viewModel.addLocationIds($event)"
        (removeLocationIds)="viewModel.removeLocationIds($event)">
      </app-template-location-selection-group>
    </div>
  </lib-sticky-body>
  <lib-sticky-footer>
    <lib-button-layout>
      <lib-button-neutral (buttonClicked)="cancel()"> Cancel </lib-button-neutral>
      <lib-button-primary (buttonClicked)="update()"> Done </lib-button-primary>
    </lib-button-layout>
  </lib-sticky-footer>
</lib-sticky-modal>
